import ButtonTabuYashirServerRequest from './ButtonTabuYashirServerRequest-redux';

export default ButtonTabuYashirServerRequest;
